import * as types from '../constants/actionsTypes';

const initialState = {
	placemarks: [],
	loading: false
}

export default function (state = initialState, action) {
	switch (action.type) {
		case types.LOAD_PLACEMARKS_REQUEST:
			return {
				...state,
				loading: true,
				placemarks: []
			}
		case types.LOAD_PLACEMARKS_SUCCESS:
			return {
				...state,
				loading: false,
				placemarks: action.placemarks
			}
		case types.LOAD_PLACEMARKS_FAILURE:
			return {
				...state,
				loading: false
			}
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./reducers/map.js